import { Component, Inject, OnInit } from '@angular/core';
import {
	ITransactionModalData,
	ITimeSheetHistory,
	IChangedFieldDetail,
	ITripModalData
} from '../../time-sheets/time-sheets.type';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TimeSheetService } from '../../time-sheets/time-sheet.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangesDisplayService } from '../../changes/changes-display.service';

@Component({
	selector: 'app-time-sheet-history-dialog',
	templateUrl: './time-sheet-history-dialog.component.html',
	styleUrls: ['./time-sheet-history-dialog.component.scss']
})
export class TimeSheetHistoryDialogComponent implements OnInit {
	constructor(
		private dialogRef: MatDialogRef<TimeSheetHistoryDialogComponent>,
		@Inject(MAT_DIALOG_DATA)
		public modalData: ITransactionModalData | ITripModalData,
		private timeSheetService: TimeSheetService,
		private changeDisplayService: ChangesDisplayService
	) { }

	public transactionHistory: IChangedFieldDetail[];
	public tripHistory: IChangedFieldDetail[];

	ngOnInit(): void {
		this.modalData.timeSheetData.timeSheetTransactionId
			? this.getTransactionHistory(this.modalData.timeSheetData.timeSheetTransactionId)
			: this.getTripHistory(this.modalData.timeSheetData.timeSheetTripId);
	}

	public getTransactionHistory(transactionId: number): void {
		this.transactionHistory = [];
		this.timeSheetService.getTransactionHistory(transactionId).subscribe(
			(DATA: ITimeSheetHistory[]) => {
				if (DATA) {
					const history: IChangedFieldDetail[] = this.changeDisplayService.convertTimeSheetHistoryToChangedFieldDetail(
						DATA
					);
					this.transactionHistory = [...this.transactionHistory, ...history];
				}
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}

	public getTripHistory(tripId: number): void {
		this.tripHistory = [];
		this.timeSheetService.getTripHistory(tripId).subscribe(
			(DATA: ITimeSheetHistory[]) => {
				if (DATA) {
					const history: IChangedFieldDetail[] = this.changeDisplayService.convertTimeSheetHistoryToChangedFieldDetail(
						DATA
					);
					this.tripHistory = [...this.tripHistory, ...history];
				}
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}

	public close(): void {
		this.dialogRef.close();
	}
}
